<template>
  <div
    class="auth-wrapper auth-v1 px-2"
  >
    <verify
      :is-verify-active.sync="isVerifyActive"
      :email="userEmail"
    />
    <b-modal
      v-model="isNewPasswordRequiredActive"
      title="New Password Required"
      hide-footer
    >
      <new-password-required
        :email="userEmail"
        :user="userData"
        @login="login"
      />
    </b-modal>
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card>
        <b-link class="brand-logo">
          <!--  <vuexy-logo /> -->
          <b-img
            :src="require('@/assets/images/logo/PRYM-blue-small.png')"
            height="50%"
            alt="PRYM Logo"
          />
        </b-link>

        <b-card-title class="mb-1 text-center">
          Welcome 👋
        </b-card-title>
        <b-card-text class="mb-2">
          Please sign-in to your account and start the adventure
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login(password)"
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="john@example.com"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Password</label>
                <b-link :to="{name:'forgot-password'}">
                  <small>Forgot Password?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <span
                v-if="loginError !== ''"
                class="text-danger"
              >
                {{ loginError }}
              </span>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              id="login"
              type="submit"
              block
              :disabled="invalid"
              style="background-color: #403F8B"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
        <div class="divider my-2">
          <div class="divider-text">
            or
          </div>
        </div>
        <div class="auth-footer-btn d-flex justify-content-center">
          <b-button
            block
            variant="outline-danger"
          >
            Sign in with Google
          </b-button>
        </div>

        <b-card-text class="text-center mt-2">
          <div class="divider my-2">
            <div class="divider-text">
              New on our platform?
            </div>
          </div>
          <b-link :to="{name:'signup'}">
            <b-button
              block
              variant="outline-primary"
            >
              Sign Up
            </b-button>
          </b-link>
        </b-card-text>

        <!-- social buttons -->

      </b-card>
    </div>
    <b-modal
      id="chooseWorkspace"
      title="Choose Workspace"
      :visible="isModalVisible"
      size="lg"
      hide-header-close
      hide-footer
      no-close-on-backdrop
    >
      <!--- a table with all the workspaces the user is a member of from the database -->
      <b-table
        :items="workspacesAndRoles"
        :fields="workspaceFields"
      >
        <template #cell(name)="data">
          {{ listWorkspaces.find(workspace => workspace.id === data.item.id).name }}
        </template>

        <template #cell(roles)="data">
          <b-badge
            :variant="highestRole(data.item.roles) === 'ADMIN' ? 'danger' : 'primary'"
          >
            {{ highestRole(data.item.roles).toUpperCase() }}
          </b-badge>
        </template>

        <template #cell(actions)="row">
          <b-button
            variant="outline-primary"
            @click="selectWorkspace(row.item)"
          >
            Select
          </b-button>
        </template>
      </b-table>
    </b-modal>

  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable no-unused-vars */
import { Auth, API } from 'aws-amplify'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BImg,
  BModal,
  BTable,
  BBadge,
} from 'bootstrap-vue'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { AbilityBuilder, Ability } from '@casl/ability'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import * as queries from '../../graphql/queries'

import Verify from './Verify.vue'
import NewPasswordRequired from './NewPasswordRequired.vue'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    //  VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Verify,
    NewPasswordRequired,
    BImg,
    BModal,
    BTable,
    BBadge,

  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      listWorkspaces: [],
      workspaces: [],
      workspaceFields: [
        { key: 'name', label: 'Name' },
        { key: 'roles', label: 'Role' },
        { key: 'actions', label: 'Actions' },
      ],
      workspacesAndRoles: [],
      isModalVisible: false,
      isNewPasswordRequiredActive: false,

      userEmail: '',
      password: '',
      status: '',
      // validation rules
      required,
      email,
      userData: {},
      loginError: '',

    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  setup() {
    const isVerifyActive = ref(false)
    return {
      // Modal
      isVerifyActive,
    }
  },
  created() {
    if (this.$route.params.email) {
      this.userEmail = this.$route.params.email
    } else {
      this.userEmail = ''
    }
    if (this.$route.params.password) {
      this.password = this.$route.params.password
    } else {
      this.password = ''
    }
    if (this.$route.params.signIn === 'true') {
      this.login(this.password)
    }
  },
  methods: {
    async login(password) {
      this.loginError = ''
      try {
        this.isNewPasswordRequiredActive = false
        // console.log(password)
        const user = await Auth.signIn(this.userEmail, password)
        // console.log(user)
        this.userData = user
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.isNewPasswordRequiredActive = true
          // console.log('new password required')
        } else if (user.challengeName === 'MFA_SETUP') {
          // console.log('mfa setup required')
        } else if (user.challengeName === 'CUSTOM_CHALLENGE') {
          // console.log('custom challenge required')
        } else if (user.challengeName === 'DEVICE_SRP_AUTH') {
          // console.log('device srp auth required')
        } else if (user.challengeName === 'DEVICE_PASSWORD_VERIFIER') {
          // console.log('device password verifier required')
        } else if (user.challengeName === 'ADMIN_NO_SRP_AUTH') {
          // console.log('admin no srp auth required')
        } else if (user.challengeName === 'CUSTOM_CHALLENGE') {
          // console.log('custom challenge required')
        } else if (user.challengeName === 'SMS_MFA') {
          // console.log('sms mfa required')
        } else if (user.challengeName === 'SELECT_MFA_TYPE') {
          // console.log('select mfa type required')
        } else if (user.challengeName === 'MFA_SETUP') {
          // console.log('mfa setup required')
        } else if (user.challengeName === 'SOFTWARE_TOKEN_MFA') {
          // console.log('software token mfa required')
        } else if (user.challengeName === 'VERIFY_SOFTWARE_TOKEN') {
          // console.log('verify software token required')
        } else {
          localStorage.setItem('userData', JSON.stringify(this.userData))

          // Sort Workspace and group roles to the workspace
          await API.graphql({
            query: queries.listWorkspaces,
          }).then(response => {
            this.listWorkspaces = response.data.listWorkspaces.items
            // console.log(this.listWorkspaces)
          })
          this.workspaces = this.userData.signInUserSession.accessToken.payload['cognito:groups']

          let workspaceIndex = 0
          this.workspaces.forEach((workspace => {
          // workspace is a string containing the workspace id and role name
          // get the workspace id
            const workspaceId = workspace.substring(0, workspace.indexOf('.'))
            // check if the workspace id is already in the workspacesAndRoles array
            workspaceIndex = this.workspacesAndRoles.findIndex(w => w.id === workspaceId)
            if (workspaceIndex > -1) {
            // if the workspace id is already in the workspacesAndRoles array, push the role to the roles array
              this.workspacesAndRoles[workspaceIndex].roles.push(workspace.substring(workspace.indexOf('.') + 1))
            } else {
            // if the workspace id is not in the workspacesAndRoles array, create a new object and push it to the array
              this.workspacesAndRoles.push({
                id: workspaceId,
                roles: [workspace.substring(workspace.indexOf('.') + 1)],
              })
            }
          }))
          // prompt the user to select workspace if they are in more than one workspace
          const currentWorkspace = JSON.parse(localStorage.getItem('workspace'))
          if (this.userData.signInUserSession.accessToken.payload['cognito:groups'].length > 3 && !currentWorkspace) {
          // Show the modal for the user to select a workspace
            this.isModalVisible = true
          } else {
            this.selectWorkspace(this.workspacesAndRoles[0])
          }
        }
      } catch (error) {
        if (error.code === 'UserNotConfirmedException') {
          this.verify()
        } else {
          this.loginError = error.message
        }
      }
    },
    verify() {
      this.isVerifyActive = true
    },
    highestRole(roles) {
      // return the highest priority role in the array
      if (roles.includes('admin')) {
        return 'admin'
      } if (roles.includes('editor')) {
        return 'editor'
      } if (roles.includes('viewer')) {
        return 'viewer'
      }
      return ''
    },
    selectWorkspace(workspace) {
      // Set the workspace in local storage
      // console.log(workspace)
      const workspaceName = this.listWorkspaces.find(w => w.id === workspace.id).name
      const workspaceRole = this.highestRole(workspace.roles)
      localStorage.setItem('workspace', JSON.stringify({ id: workspace.id, name: workspaceName }))

      // Set the ability based on the role
      const { can, cannot, rules } = new AbilityBuilder(Ability)
      if (workspaceRole === 'admin') {
        can('manage', 'all')
      } else if (workspaceRole === 'editor') {
        can('manage', 'all')
        cannot('manage', 'workspace')
      } else if (workspaceRole === 'viewer') {
        can('read', 'all')
      }
      this.userData.ability = rules
      this.$ability.update(rules)

      // Set Token
      useJwt.setToken(this.userData.signInUserSession.accessToken.jwtToken)
      useJwt.setRefreshToken(this.userData.signInUserSession.refreshToken.token)
      localStorage.setItem('userData', JSON.stringify(this.userData))

      // Redirect to home page
      this.$router.push({ name: 'home' })
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: `Welcome ${this.userData.attributes.email}!`,
          icon: 'CoffeeIcon',
          variant: 'success',
          text: `You have successfully logged in as ${workspaceRole}. Now you can start to explore!`,
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.auth-wrapper.auth-v1 {
    background: url("https://uploads-ssl.webflow.com/61489b3e5856f80b844d9a07/61489b3e5856f824ec4d9b48_background-pricing-tech-ui-kit-webflow-template.svg");
}
.btn-secondary {
    border-color: #171663 !important;
    background-color: #171663!important;
}
a {
    color: #7844fc
}
</style>
